import type { ReactNode } from 'react';
import { FirmHeader, FirmPage } from './FirmHeader';

/** Simple centered card for link problems and session messages. */
export function FirmMessage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <FirmPage>
      <FirmHeader subtitle="Firm onboarding" />
      <main className="mx-auto max-w-[640px] px-4 py-10 sm:px-6 sm:py-14">
        <section className="rounded-2xl border border-line bg-white p-6 shadow-card sm:p-8">
          <h1 className="mb-3 mt-0 text-[26px] font-bold leading-[1.2] tracking-[-0.02em]">{title}</h1>
          <div className="flex flex-col gap-4 text-[15px] leading-[1.55] text-ink-2">{children}</div>
        </section>
      </main>
    </FirmPage>
  );
}
